<template>
  <div class="w-full h-full flex flex-col border-box relative">

    <apollo-mutation
      :mutation='updateTemplateMutation'
      fetch-policy='cache-and-network'
      :variables="{id:template.id,data:templateData,title:template.title,labels:template.labels,thumbnailImage,tags:template.tags,public:isPublic}">

      <template v-slot="{mutate,loading,error}">
        <div class='flex'>
          <loading v-if='loading' />
          <div v-if='!loading' class="grow mx-2">
            <input v-model='template.title' :class="nameInputClasses" placeholder='Name' type="text" />
            <p v-if='validationError' class="text-red-500 text-xs italic">Please enter a name.</p>
            <input v-model='template.labels' :class="nameInputClasses" placeholder='Labels' type="text" />
            <input v-model='template.tags' :class="nameInputClasses" placeholder='Tags' type="text" />
          </div>
          <pbc-button @click='chooseImage = true'>
            <img :src='imageUrl' class="object-contain w-16 h-16" />
          </pbc-button>
          <toggle-switch v-model='isPublic' label='Public' />
          <pbc-button @click='onSave(mutate)'>
            <post class="mx-2"/>
            <span class="mr-2">Save</span>
          </pbc-button>
        </div>
        <toggle-switch v-model='enableAnimation' label='Enable Animation' />
          <!--
        <div v-if='gamedata && gamedata.template' class="text-white">{{gamedata.template}}</div>
          -->
        <div v-if='editingComponent && editingComponent.id' class="flex">
          <!--
          <p class="text-white">
          {{editingComponent.id}} - {{ editingComponent.type }}
          </p>
          -->
          <toggle-switch v-model='editingComponentIsEditable' label='Editable' />
          <toggle-switch v-model='editingComponentIsSelectable' label='Selectable' />
          <pbc-button @click='hackClearSelections'>Clear selections</pbc-button>
        </div>
      </template>
    </apollo-mutation>

    <choose-or-upload-image v-if='chooseImage' game-id='chezzer' @select='onSelectImage' />

    <editor v-if='gamedata && gamedata.template'
            class="grow"
            :transforms-and-source='transformsAndSource'
            :gamedata='gamedata'
            :edit-template='true'
            background-color='#313131'
            @select='onSelect'
            />

    <fill-loader v-if='componentLoadingState[0]' />

    <pbc-message ref="message" />

  </div>
</template>
<script>
import Post from '@icons/Post.vue';
import ChooseOrUploadImage from '@ui/organisms/ChooseOrUploadImage.vue';
import Gamedata from '@edit/tree/gamedata.js';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import uuid from 'uuid';
import ComponentLazyLoader from '@/lazyloader.js';
import { cloneDeep } from 'lodash';
import { updateTemplateMutation, getTemplateQuery } from '@/gql/Queries.js';

import gql from 'graphql-tag';
//const {componentLoadingState, fn:UndoRenderer}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/UndoRenderer.vue'));
const {componentLoadingState, fn:Editor}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/Editor.vue'));

let dummyUserId = uuid.v4();

const saveToyMutation = gql(`
mutation saveToy($id: String!, $name: String!, $toy: String!, $description: String, $thumbnailImage: String, $public: Boolean) {
  saveToy(id: $id, name: $name, toy: $toy, description: $description, thumbnailImage: $thumbnailImage, public: $public) 
}
`);

export default {
  inject: ['api'],
  props: {
  },
  apollo: {
    getTemplate: {
      query: getTemplateQuery,
      variables() {
        return {
          id: this.templateId
        }
      },
      update(data) {
        console.log('check data', data);
        const gamedata = new Gamedata(JSON.parse(data.getTemplate.data));
        const getTemplate = data.getTemplate;
        const transformsAndSource = gamedata.getSceneByIndex(0);
        return {
          transformsAndSource,
          getTemplate
        }
      },
      skip() {
        return !!this.gamedata;
      }
    },
  },
  methods: {
    async onSave(mutate) {
      const blockedSelections = [];
      const transforms = this.transformsAndSource.gamedata.findAllTransforms();
      transforms.forEach( ({id}) => {
        const canSelect = this.possibleTemplateSelections.includes(id) || this.possibleTemplateEdits.includes(id)
        if (!canSelect) {
          blockedSelections.push(id);
        }
      });
      this.$set(this.gamedata.template, 'blockedSelections', blockedSelections);
      console.log('blockedSelections', blockedSelections);

      const variables = {
        id:this.template.id,
        data:this.templateData,
        title:this.template.title,
        labels:this.template.labels,
        thumbnailImage:this.thumbnailImage,
        tags:this.template.tags,
        public:this.isPublic
      };

      await mutate({
        variables
      });
    },
    onSelect({transform,component}) {
      this.editingComponent = component||{};
      this.editingTransform = transform||{};
    },
    onSelectImage(img) {
      console.log('selected image', img);
      this.thumbnailImage = img.id;
      this.chooseImage = false;
    },
    getCleanedData() {
      return this.toy;
    },
    hackClearSelections() {
      this.gamedata.template.components = [];
      this.gamedata.template.selectable = [];
    }
  },
  data() {
    return {
      getTemplate:{
        transformsAndSource:{gamedata:{}},
        getTemplate:{}
      },
      updateTemplateMutation,
      validationError:false,
      validationErrorPostEmpty:false,
      componentLoadingState,
      chooseImage: false,
      saveToyMutation,
      public:false,
      editingComponent:{},
      editingTransform:{},
    }
  },
  mounted() {
    this.$store.commit('isAdvancedMode', true);
  },
  beforeDestroy() {
  },
  components: {
    Editor,
    PbcMessage,
    Post,
    ChooseOrUploadImage
  },
  computed:{
    gamedata() {
      return this.getTemplate.transformsAndSource.gamedata.gamedata;
    },
    transformsAndSource() {
      return this.getTemplate.transformsAndSource;
    },
    templateData() {
      return JSON.stringify(this.getTemplate.transformsAndSource.gamedata.gamedata);
    },
    templateId() {
      return this.$route.params.templateId;
    },
    backgroundColor() {
      return this.getTemplate.transformsAndSource.gamedata.game.bgcolor.replace('0x', '#')
    },
    template() {
      return this.getTemplate.getTemplate;
    },
    nameInputClasses() {
      const classes = ["pbc-standard-input", "text-lg", "my-1"];
      if (this.validationError) {
        classes.push("border-red-500 border border-2");
      }
      return classes;
    },
    isPublic:{
      get() {
        return !!this.template.public;
      },
      set(nv) {
        this.template.public = nv;
      }
    },
    editingComponentIsSelectable: {
      get() {
        return this.editingComponent.id && (this.gamedata.template.selectable||[]).filter( ({component}) => {
          return component === this.editingComponent.id;
        }).length > 0;
      },
      set(nv) {
        if (typeof(this.gamedata.template.selectable) === 'undefined') {
          this.$set(this.gamedata.template, 'selectable', []);
        }
        const c = this.gamedata.template.selectable;
        const find = ({component}) => {
          return component === this.editingComponent.id;
        }
        const notFind = ({component}) => {
          return component !== this.editingComponent.id;
        }
        if (nv) {
          !c.filter(find).length && c.push({
            component:this.editingComponent.id,
            transform:this.editingTransform.id
          });
        } else {
          this.gamedata.template.selectable = c.filter(notFind);
        }
      }
    },
    editingComponentIsEditable: {
      get() {
        return this.editingComponent.id && this.gamedata.template.components.filter( ({component}) => {
          return component === this.editingComponent.id;
        }).length > 0;
      },
      set(nv) {
        const c = this.gamedata.template.components;
        const find = ({component}) => {
          return component === this.editingComponent.id;
        }
        const notFind = ({component}) => {
          return component !== this.editingComponent.id;
        }
        if (nv) {
          !c.filter(find).length && c.push({
            component:this.editingComponent.id,
            transform:this.editingTransform.id
          });
        } else {
          this.gamedata.template.components = c.filter(notFind);
        }
      }
    },
    imageUrl() {
      return this.api.makeImageUrlEditor(this.thumbnailImage || 'placeholder.png');
    },
    thumbnailImage: {
      get() {
        return this.template.thumbnailImage;
      },
      set(nv) {
        this.template.thumbnailImage = nv;
      }
    },
    enableAnimation: {
      get() {
        return this.gamedata.game.timelimit !== -1
      },
      set(nv) {
        if (nv) {
          this.gamedata.game.timelimit = 3;
        } else {
          this.gamedata.game.timelimit = -1;
        }
      }
    },
    possibleTemplateSelections() {
      return (this.gamedata.template.components||[]).map( ({transform}) => {
        return transform;
      })
    },
    possibleTemplateEdits() {
      return (this.gamedata.template.selectable||[]).map( ({transform}) => {
        return transform;
      })
    }

  },
  watch: {
    name(nv) {
      if (nv.length > 0) {
        this.validationError = false;
      }
    }
  }
}
</script>
